import { matrix, transpose, multiply, inv, median } from "mathjs";

const normalizeX = (data, period) => {
	if( period > 0 ) {
		const periodMs = period > 0 ? period * 1000 : 0;
		
		const T = data.map(({x}) => x).sort();
		const tMedian = median(T);
	
		return value => (value - tMedian) / periodMs;
	} else {
		return x => x
	}

}

// Source: https://www.omnicalculator.com/statistics/cubic-regression#definition-of-cubic-regression
// https://stackoverflow.com/questions/28269021/how-do-i-create-a-best-fit-polynomial-curve-in-javascript
const cubicRegression = (data, degree, period) => {
	const X = [];
	const Y = [];
	
	const tNorm = normalizeX(data, period); 		
	
	for( let entry of data ) {
		const { x, y } = entry; 
		
		const t = tNorm(x);
		
		const record = [1];
		
		for(let index = 1; index <= degree; index++) {
			record.push( Math.pow(t, index) );
		} 		
		
		if( period > 0 ) {
			record.push( Math.sin( 2 * Math.PI * t ) );
			record.push( Math.cos( 2 * Math.PI * t ) - 1 ) ;
		}
		
		X.push(record);	
		
		Y.push( y );
	}
		
	const matrixX = matrix(X);
	const matrixY = transpose([Y]);
	const matrixT = transpose(matrixX);
			
	const matrixTtimesX = multiply(matrixT, matrixX);
	
	const squareInverse = inv( matrixTtimesX );
	const matrixMulX = multiply( matrixT, matrixY);
	const solution = multiply( squareInverse, matrixMulX);
	
	const parameters = [];
	
	for( let i = 0; i <= degree; i++ ) {
		const parameter = solution.get([i, 0]);
		parameters.push( parameter );
	}
	
	const a = solution.get([0, 0]);
	const b = [];
	
	for( let i = 1; i <= degree; i++) {
		const s = solution.get([i, 0]);
		b.push( s );
	} 
	
	const c = period > 0 ? solution.get([degree + 1, 0]) : undefined;
	const d = period > 0 ? solution.get([degree + 2, 0]) : undefined;	
	
	return x => {
		let result = a;
		const t = tNorm(x);
		
		let p = 1;
		for( let value of b ) {
			result = result + (value * Math.pow(t, p));
			p++;
		}
		
		if( c !== undefined ) {
			const sinus = Math.sin(2 * Math.PI * t);
			const cosinus = Math.cos(2 * Math.PI * t) - 1;
		
			result = result + (c * sinus) + (d * cosinus)
		}
		
		return result;    	
	}
}

const trendLine = (data, degree, period) => {
	if( degree > 0 ) {
		return cubicRegression(data, degree, period);
	} else {
		return () => 1;
	}  
}

export { trendLine };